import React from 'react';
import { ReactComponent as ArrowRightIcon } from '../../assets/images/icons/arrow-right-dark.svg';

export default function ArrowRightDark(props) {
  return <ArrowRightIcon className={`icon ${props.className}`} />;
}
